import './ScreenCover.scss';
import { Screen } from '@components/Component/Container/Screen/Screen.js';
export class ScreenCover extends Screen {
    constructor() {
        super(...arguments);
        this.componentName = 'ScreenCover';
    }
    draw() {
        super.draw();
        this.propertyGet$('currentForm')
            .subscribe((form) => {
            this.rootElement.classList.toggle('show', !!form);
        });
    }
    unloadForm() {
        this.ScreenManager.screenCoverActive = false;
        return super.unloadForm();
    }
    template() {
        return '<div class="screen-content"></div>';
    }
}
ScreenCover.VERSION = '$Revision: 121419 $';
